export const FRASES_INSPIRADORAS = [
  "Creemos en tu momento.",
  "Transformando momentos en oportunidades.",
  "Porque cada persona tiene su momento.",
  "El poder de una oportunidad.",
  "Tu momento empieza aquí.",
  "El momento que cambia tu historia.",
  "Porque cada momento merece una oportunidad."
];
